import { RequiredAsterisk, FieldValidationErrorMsg } from '../../../../sitel/demon/ui/atoms/form';
/**
 * The moreInfoRequest object is the extra_data->moreInfo that comes from oh admin
 * It might have several entries, some already filled some not, some requesting just uploads, some just questions some both
 * 
 * @param {*} param0 
 * @returns 
 */
export default function TextAreaReligiousAdditionalInfo({ moreInfoRequest, register, errors }) {

  let arrayOfQuestions = [];
  for (const key in moreInfoRequest) {
    if (moreInfoRequest.hasOwnProperty(key) && moreInfoRequest[key].question) {
        //no longer needed, it is done on server const id = key.replace(/[^a-zA-Z0-9]/g, '');
        arrayOfQuestions.push(
          <div className='form-group row align-items-start py-3 p-md-2'>
            <label htmlFor={key} className='col-md-6 col-form-label' style={{ paddingTop: 0 }}>
              {moreInfoRequest[key].question}
              <br />Asked by: the Exemption Team
              <br />When: {moreInfoRequest[key].whenRequested}
            </label>
            <div className='col-md-6'>
              <textarea 
                className='form-control'
                id={key}
                rows='4' 
                {...register(key)}
                defaultValue={moreInfoRequest[key].userResponse || ''}
                disabled={moreInfoRequest[key].userResponse && moreInfoRequest[key].userResponse.length>0?true:false}>
              </textarea>
              <FieldValidationErrorMsg field={key} errors={errors} />
            </div>
          </div>
        );
    }
  }
  return (
    <>
      {arrayOfQuestions.map(item=>item)}
    </>
  );
}
